import { useDispatch, useSelector } from 'react-redux'
import { selectChatId, selectChatInitialized, setChatInitialized, setWelcomeMessage } from 'store/messages'
import { useCallback, useMemo } from 'react'
import { getGuestChat, updateChatRole } from 'api/index'
import { getChatRole } from 'utils/query-params'

export const useChat = () => {
  const dispatch = useDispatch()
  const chatRole = getChatRole()
  const chatInitialized = useSelector(selectChatInitialized)
  const chatId = useSelector(selectChatId)

  const initializeChat = useCallback(async () => {
    console.debug({ chatId })
    try {
      if (!chatId) {
        await getGuestChat()
        if (chatRole) {
          console.debug('here', { chatRole })
          await updateChatRole(chatRole, false).catch(console.error)
        } else {
          dispatch(setWelcomeMessage({ withChatRoleButtons: true }))
        }
        dispatch(setChatInitialized(true))
      }
    } catch (e) {
      console.error({ errorInitializedChat: e })
    }
  }, [chatInitialized])

  // /**
  //  * @description If the user is logged in, get the chat with the user id
  //  * @description If user is not logged, open the guest chat and ask for the role
  //  */
  // useEffect(() => {
  //   initializeChat()
  // }, [captcha])
  return useMemo(() => initializeChat, [initializeChat])
}
